import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initWebVitals } from "./utils/webVitals";

// Defensive patch: Google Translate & other browser translators manipulate
// text nodes which confuses React reconciliation (insertBefore/removeChild errors).
// We wrap the native DOM methods so they become no-ops when the node is no
// longer a child (instead of throwing). See https://github.com/facebook/react/issues/11538
if (typeof Node !== 'undefined') {
  const _origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        return child.parentNode.removeChild(child);
      }
      return child;
    }
    return _origRemoveChild.call(this, child);
  };
  const _origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return _origInsertBefore.call(this, newNode, null); // append instead
    }
    return _origInsertBefore.call(this, newNode, referenceNode);
  };
}

// Silence harmless "ResizeObserver loop completed with undelivered notifications"
// warning thrown by Radix UI / Recharts / Headless UI on viewport changes.
// This is a benign browser timing warning (not an actual error). It doesn't
// affect functionality but pollutes the dev overlay.
// See https://github.com/WICG/resize-observer/issues/38
if (typeof window !== 'undefined') {
  const RESIZE_OBSERVER_ERR_RE = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
  window.addEventListener('error', (e) => {
    if (e && e.message && RESIZE_OBSERVER_ERR_RE.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  });
  window.addEventListener('unhandledrejection', (e) => {
    if (e && e.reason && typeof e.reason.message === 'string' && RESIZE_OBSERVER_ERR_RE.test(e.reason.message)) {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// RUM (Real User Monitoring) — Core Web Vitals envoyés au backend.
// Démarre après le render pour ne pas bloquer le first paint.
initWebVitals();
